import React, { Component } from "react"
import "./DuoDatePicker.css"

class DuoDatePicker extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { id, type, date, onChange } = this.props
    return <input id={id} type={type} value={date} onChange={onChange} />
  }
}

export default DuoDatePicker



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/DuoDatePicker.js